import AutoketingModal from './AutoketingModal';

export default AutoketingModal;
